import { useEffect, useRef, useState } from "react";
import AddIcon from '@mui/icons-material/Add';
import ProgressBarODM from "./ProgressBar";
import { assetti, esecuzioni, Esercizio, finalita, modalita } from "../interfaces/Esercizio";
import CompartiMuscolari from "./CompartiMuscolari";
import ImageUploadPreview from "./ImageUploadPreview";
import ModalPosizioneFinalita from "./ModalPosizioneFinalità";
import ComplexFunctionModal from "./ComplexFunctionModal";
import ModeIcon from '@mui/icons-material/Mode';
import IssueHandlingModal from "./IssueHandlingModal";
import ReminderModal from "./ReminderModal";
import { TextField } from "@mui/material";

interface SportEducativoDetailsProps {
    //token: string;
    esercizio: Esercizio;
    handleChange: <K extends keyof Esercizio>(key: K, value: Esercizio[K]) => void;
}


interface select {
    value: string;
    label: string;
}


export default function SportEducativoDetails({ esercizio, handleChange }: SportEducativoDetailsProps) {
    const [modalEF, setModalEF] = useState<boolean>(false);
    const [categoryList, setCategoryList] = useState<select[]>([]);

    const fetchCategory = async () => {
        try {
            const headers = new Headers();
            //if (token) {
            //    headers.set('Authorization', `Token ${token}`);
            //}
            headers.set('Accept', 'application/json');
            const requestInit: RequestInit = {
                method: 'GET',
                headers: headers,
                credentials: 'include',
            }
            const response = await fetch('/api/v0/activity/categories', requestInit);
            if (!response.ok) throw new Error('Errore nel recupero delle attività');
            const data = await response.json();
            setCategoryList(data);
        } catch (err: any) {
            console.log(err.message);
        }
    };

    useEffect(() => {
        fetchCategory()
    }, []);



    return (
        <div className="p-4 bg-white shadow-md rounded-lg max-w-lg mx-auto">

            <div className="row justify-content-between">
                <div className="col-6">
                    <h5 className="font-semibold mb-3">Immagine di anteprima</h5>
                </div>
                <div className="col-6 text-end">
                    <ImageUploadPreview
                        //token={token}
                        image={esercizio.preview_image}
                        onChange={(newImage) => handleChange("preview_image", newImage)}
                    />
                </div>
            </div>

            <h5 className="font-semibold mb-3">Info generali</h5>
            <TextField
                label="Nome corto*"
                variant="outlined"
                fullWidth
                value={esercizio.full_name}
                onChange={(e) => handleChange("full_name", e.target.value)}
                inputProps={{ maxLength: 32 }}
                helperText={`${esercizio.full_name.length}/32`}
                FormHelperTextProps={{ style: { textAlign: 'right' } }}
                className="mb-3"
            />
            <TextField
                label="Descrizione*"
                variant="outlined"
                fullWidth
                multiline
                rows={3}
                value={esercizio.full_description}
                onChange={(e) => handleChange("full_description", e.target.value)}
                inputProps={{ maxLength: 130 }}
                helperText={`${esercizio.full_description.length}/130`}
                FormHelperTextProps={{ style: { textAlign: 'right' } }}
                className="mb-3"
            />

            <div className="row">
                <div className="col-5 d-flex mb-3">
                    <input
                        disabled
                        className="form-control me-3"
                        placeholder="Posizione*"
                        value={esercizio.position}
                    />
                    <button className="btn btn-dark" onClick={() => setModalEF(!modalEF)}>
                        <AddIcon />
                    </button>
                    <ModalPosizioneFinalita
                        //token={token}
                        open={modalEF}
                        onClose={() => setModalEF(false)}
                        esercizio={esercizio}
                        positionChange={(e) => handleChange("position", e.value)}
                        purposeChange={(e) => handleChange("purpose", e.value)}
                    />
                </div>
            </div>

            <div className="mb-4">
                <h5 className="font-semibold mb-1">Categoria</h5>
                <select
                    className="form-control"
                    value={esercizio.category}
                    onChange={(e) => handleChange("category", e.target.value)}
                >
                    {categoryList.map((option) => (
                        <option key={option.value} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </select>
            </div>
        </div>
    );
}